import TextV1 from "../../../../components/form_builder/elements/text/TextV1.vue";

export default {
  componentName: "fb-text-v1",
  component: TextV1,
  defaultAttrs: {
    properties: {
      value: "Example text",
      style: {},
      hideOnEdit: false,
      hideOnView: false,
      hidden: false
    }
  },
  gridAttrs: {
    type: "template",
    hidden: true,
    template: ({ value }) => value
  },
  validate: () => {
    return [];
  }
};
